import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {of} from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class InstagramService {
    private http = inject(HttpClient);


    // Instagram Array
    public getInstagramData() {
        // return this.http.get('https://api.instagram.com/v1/users/self/media/recent/?access_token=ACCESS_TOLEN&count=15')
        return of[0];
    }

}
